import { Col, Divider, Row } from "antd";
import registerIcon from "../../../assets/icons/register-icon.svg";
import beneficiaryIcon from "../../../assets/icons/register-icon-block-1.svg";
import sponsorIcon from "../../../assets/icons/register-icon-block-2.svg";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="takaful--share-cases-container">
        <div className="takaful--share-cases-title-grand">
          <img width={32} src={registerIcon} alt="takaful" />
          <span>نوع المستخدم</span>
        </div>
        <Divider />
        <div className="takaful--share-cases-title-container">
          <Row justify="space-between" gutter={16}>
            <Col xxl={11} xl={11} lg={12} md={12} sm={12} xs={12}>
              <div
                className="takaful--register-card"
                onClick={() => navigate("/add-sponsor")}
              >
                <img width={70} src={sponsorIcon} alt="" />
              </div>
              <div className="takaful--register-card-container">
                <span>كافل جديد</span>
              </div>
            </Col>
            <Col
              xxl={11}
              xl={11}
              lg={12}
              md={12}
              sm={12}
              xs={12}
              onClick={() => navigate("/beneficiary/add")}
            >
              <div className="takaful--register-card">
                <img width={70} src={beneficiaryIcon} alt="" />
              </div>
              <div className="takaful--register-card-container">
                <span>مستفيد جديد</span>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Register;
